import axios from 'axios';

// Central axios configuration: attach the auth token to every request and
// bounce to /login on 401. Imported once in index.js so it applies app-wide.

export const API = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const TOKEN_KEY = 'authToken';

export const getToken = () => localStorage.getItem(TOKEN_KEY) || '';
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);

// Persist the authenticated user (email/role/status/team) for routing decisions.
export const setUser = (u) => {
  if (!u) return;
  localStorage.setItem('userEmail', u.email || '');
  localStorage.setItem('userRole', u.role || 'user');
  localStorage.setItem('userStatus', u.status || 'pending');
  // Membre d'équipe : permissions renvoyées en objet (via /me) ou en chaîne JSON (via /login)
  if (u.team_owner_id) {
    let perms = u.permissions;
    if (typeof perms === 'string') { try { perms = JSON.parse(perms); } catch { perms = {}; } }
    localStorage.setItem('teamMember', '1');
    localStorage.setItem('teamPerms', JSON.stringify(perms || {}));
  } else {
    localStorage.removeItem('teamMember');
    localStorage.removeItem('teamPerms');
  }
};
export const getUserRole = () => localStorage.getItem('userRole') || 'user';
export const getUserStatus = () => localStorage.getItem('userStatus') || 'pending';
export const isAdmin = () => getUserRole() === 'admin';

// ── équipe : permissions du membre connecté ──────────────────────────────────
export const isTeamMember = () => localStorage.getItem('teamMember') === '1';
export const getPerms = () => {
  if (!isTeamMember()) return null; // propriétaire : accès complet
  try { return JSON.parse(localStorage.getItem('teamPerms') || '{}'); } catch { return {}; }
};
// hasPage('dashboard'|'create'|'scheduled'|'automation'|'accounts'|'library'|'gallery'|'proxies'|'profiles'|'groups')
export const hasPage = (key) => {
  const p = getPerms();
  return !p || (p.pages || []).includes(key);
};
export const PAGE_PATHS = {
  dashboard: '/', create: '/post-creator', scheduled: '/scheduled', automation: '/automation',
  accounts: '/sessions', library: '/library', gallery: '/gallery', proxies: '/proxies',
  profiles: '/profiles', groups: '/account-profiles',
};
// Première page autorisée du membre (fallback des redirections).
export const firstAllowedPath = () => {
  const p = getPerms();
  if (!p) return '/';
  for (const key of Object.keys(PAGE_PATHS)) {
    if ((p.pages || []).includes(key)) return PAGE_PATHS[key];
  }
  return '/';
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('userEmail');
  localStorage.removeItem('userRole');
  localStorage.removeItem('userStatus');
  localStorage.removeItem('teamMember');
  localStorage.removeItem('teamPerms');
};

// Attach bearer token on every outgoing request.
axios.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 401 → invalid/expired token: clear and bounce to login.
// 403 inactive → account not approved / subscription expired: bounce to /pending.
axios.interceptors.response.use(
  (res) => res,
  (err) => {
    const r = err.response;
    if (r && r.status === 401) {
      clearAuth();
      if (!window.location.pathname.startsWith('/login')) {
        window.location.replace('/login');
      }
    } else if (r && r.status === 403 && r.data && r.data.code === 'inactive') {
      localStorage.setItem('userStatus', r.data.status || 'pending');
      if (!window.location.pathname.startsWith('/pending')) {
        window.location.replace('/pending');
      }
    }
    return Promise.reject(err);
  }
);

export default axios;
